import React from 'react';
import BackButton from "../components/utils/BackButton";

class WithBackButton extends React.Component {
    render() {
        return (
            <React.Fragment>
                <BackButton />
                {this.props.children}
                <BackButton />
            </React.Fragment>
        );
    }
}

export default WithBackButton;
